export default "__VITE_PUBLIC_ASSET__4481f255__"